import React from "react";
import NavBar from "../Navbar/Navbar";
import "./HeroSection.css";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className="relative w-full flex justify-center bg-[#F6F1EB]  py-8 sm:py-6 md:px-8">
      <img
        src="/assets/img/bgGrid.png"
        className="absolute top-0 left-0 h-full w-full "
      />
      <div className="w-full max-w-6xl bg-transparent">
        <NavBar />

        <div className="grid mt-3 grid-cols-1 lg:grid-cols-2 items-center gap-10">
          {/* Left Content */}
          <div className="bg-transparent z-30">
            <h2 className="text-3xl text-[#000000] leading-[0.9] [@media(max-width:1094px)]:text-[3.2rem] font-bomstad-semibold sm:text-5xl md:text-5xl md:leading-[1]  lg:text-[4rem] lg:w-[150%]">
              Business Loans: <br />
              Fuel Your Growth with <br />
              <span className="italic font-pp-hatton text-[2.8rem] sm:text-[3.2rem] md:text-[3.5rem] [@media(max-width:1094px)]:text-[3.2rem] lg:text-[3.8rem] highlight-behind text-black relative inline-block">
                the Right Funding
              </span>
            </h2>

            {/* Feature Strip */}
            <div className="flex font-atkinson w-full border-t-[2px] mt-8 md:mt-10 border-b-[2px] font-medium text-base md:text-lg leading-[1.2] border-black text-left">
              <div className="flex-1 p-2 md:p-3 relative">
                <p>
                  Get up-to <strong>1 Cr</strong>
                  <br />
                  in Unsecured Business Loan
                </p>
                <div className="absolute top-[-3px] left-0 w-[80%] h-3  bg-[#FBF8F3] " />
              </div>

              <div className="relative flex-1 p-2 md:p-3 border-l-[2px] border-r-[2px] border-black">
                <p>
                  Customized
                  <br />
                  Loans for Indian <strong>MSMEs</strong>
                </p>
              </div>

              <div className="relative flex-1 my-auto p-2 md:p-3">
                <p>
                  Get offers from
                  <br />
                  Banks/NBFCs
                </p>
                <div className="absolute bottom-[-3px] right-0 w-[80%] h-3  bg-[#FBF8F3]" />
              </div>
            </div>

            {/* CTA */}
            <div className="relative p-4 md:p-5 rounded-xl font-atkinson bg-transparent mt-4 w-full sm:w-[95%] lg:w-[100%] z-0">
              <img
                src="/assets/img/Desktop Personal loan Patch.png"
                className="absolute top-0 left-0 w-full h-full -z-10"
              />
              <p className="mb-3 md:mb-4 text-lg md:text-2xl text-gray-800">
                Looking to Expand Your Business? <br />
                Get the Right Financing Today!
              </p>
              <button
                onClick={() => {
                  navigate("/business-loan-v1");
                }}
                className="flex justify-center items-center gap-3  transition-all duration-300 ease-in-out transform hover:scale-105 text-black border-[1.5px] border-black text-sm md:text-lg px-4 py-2 rounded-full "
              >
                Apply Now
                <img
                  src="/assets/img/cta_arrow_new.png"
                  className="w-[20px] md:w-[24px]"
                />
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden sm:flex  relative justify-center lg:justify-end">
            <img
              src="/assets/img/Desktop business loan image.png"
              alt="Business Loan"
              className="rounded-3xl w-full h-full max-w-[200px] md:max-w-sm lg:max-w-lg"
            />

            {/* <img
                            src="/assets/img/Vector (5).png"
                            alt="Overlay"
                            className="absolute top-[4%] left-[5%] md:top-[-4px] md:left-[47px] h-[130px] w-[130px] md:h-[190px] md:w-[190px] rounded-3xl"
                        /> */}
          </div>
        </div>
      </div>
    </section>
  );
}
